import React from 'react';

import {WebsocketContext} from 'app/ws/context';

export interface WebsocketConsumerProps {
  sendWebsocketMessage: (message: string) => void;
  isWSOpen: boolean;
  isWSClosing: boolean;
}

export function websocketConsumer<P>(
  WsConsumerWrappedComponent: React.ComponentType<P & WebsocketConsumerProps>
): React.ComponentType<P> {
  return function WebsocketConsumer(props: P) {
    return (
      <WebsocketContext.Consumer>
        {({sendWebsocketMessage, isWSOpen, isWSClosing}) => (
          <WsConsumerWrappedComponent
            {...props}
            sendWebsocketMessage={sendWebsocketMessage}
            isWSOpen={isWSOpen}
            isWSClosing={isWSClosing}
          />
        )}
      </WebsocketContext.Consumer>
    );
  };
}
